import { injectable } from 'inversify';
import { action, makeObservable, observable } from 'mobx';

export enum QuadroLayoutType {
  ACCENTED = 'ACCENTED',
  SYMMETRICAL = 'SYMMETRICAL'
}

@injectable()
export class QuadroLayoutStateStore {
  @observable
  private _activeQuadroLayoutType: QuadroLayoutType = QuadroLayoutType.SYMMETRICAL;

  public constructor() {
    makeObservable(this);
  }

  public get activeQuadroLayoutType(): QuadroLayoutType {
    return this._activeQuadroLayoutType;
  }

  @action
  public setActiveQuadroLayoutType(layoutType: QuadroLayoutType): void {
    this._activeQuadroLayoutType = layoutType;
  }
}
